// import { redirectUrl } from './redirectUrl.js'
// import $ from "jquery";
import * as http from 'utils/http'
/*
 Ajax 请求， 推荐偷懒的写法
 请注意命名方法：homeServices => 采用驼峰，后面跟上Services
 */
import FormatDate from '@core/filters'
import SideBar from 'components/SideBar/SideBar.vue'
import TagsView from 'components/TagsView/TagsView.vue'
import changePassword from 'components/changPassword/index.vue'
import remoteJs from 'utils/watermark/index.vue'
import downHint from '@/components/downHint/downHint.vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import unreadInternalMessage from './unreadInternalMessage'
import unreadNotice from './dialog/unread-notice.vue'
import * as homeServices from './home-service'
const baseUrl =
  process.env.NODE_ENV == 'production'
    ? `${window.location.protocol}//${window.location.host}/popadmin/admin`
    : '/popadmin/admin'
export default {
  name: 'POP',
  components: {
    SideBar,
    TagsView,
    changePassword,
    unreadNotice,
    remoteJs,
    downHint,
    unreadInternalMessage,
  },
  data() {
    const validPassword = (rule, value, callback) => {
      const reg = /^[0-9a-zA-Z]*$/
      if (!reg.test(value)) {
        callback(new Error('密码只支持数字英文！'))
      } else {
        callback()
      }
    }
    const validResetPass = (rule, value, callback) => {
      if (value !== this.ruleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      checked: false,
      expireDate: '企业资质过期',
      outerVisible: false, // 重要待办事项
      wXVisible: false, // 微信账户申请
      isFrame: {
        isUse: false
      },
      FormatDate,
      pageUrl: 'http://localhostsso.yunjiglobal.com',
      images: {
        logo: require('./images/logo.png')
      },
      changePwd: false,
      isShow: true,
      menu: [],
      isRouterAlive: true, // 是否刷新
      changePasswordDialog: false, // 修改密码
      url: '',
      selectedNavList: [
        {
          menuName: '首页',
          url: 'index',
          isCheck: true,
          identify: 'agent-index'
        }
      ], // 已选中的菜单列表
      user: {},
      // 店铺类型:1-旗舰店;2-卖场型旗舰店;3-专营店;
      storeTypeList: [
        {
          label: '旗舰店',
          value: 1
        },
        {
          label: '卖场型旗舰店',
          value: 2
        },
        {
          label: '专营店',
          value: 3
        }
      ],
      firstCategList: [],
      currentLink: '',
      messgeTip: null,
      NoOrderBillingService: false,
      promotionCheckDialog: false, // 促销函确认
      qualificationCheckDialog:false, //资质核验确认
      costNum: 0,
      promiseNum: 0,
      adventCount: 0, // 临期资质商品数
      expiredCount: 0, // 过期资质商品数
      saleToolNeedHandActivityCount: 0, // 营销工具报名待处理数量
      beTimeoutUnSendCount: 0, // 抽奖奖品未发货数量
      noticeDialog: false, // 公告弹窗
      noticeDialogDataList: [], // 公告弹窗数据列表
      noticeDialogData: '', // 公告弹窗数据
      noticeDialogDataIndex: 0, // 多条数据下标
      ignoreCheckList: ['/popadminweb/bill-detail', '/popadminweb/reward-bill', '/popadminweb/sales-bill'], // 不需要调用的未处理函和采购退货地址接口的
      // 待办事项中各状态资质数量
      adventDateNum:0, //关联下架临期
      outDateNum:0, //关联下架过期
      rejectNum:0, //关联下架被驳回
    }
  },
  mounted() {
    if (Object.keys(this.$store.state.user.detailInfo).length) {
      this.user = this.$store.state.user.detailInfo || {}
      if (this.user.isNeedPopup === '1') this.wXVisible = true
      this.countSupplierUpcomingLetter()
    } else {
      this.checkNewTaskStatus()
    }
    if (this.$route.query.needChangPwd == 2) {
      this.changePwd = true
      this.messgeTip = this.$message({
        type: 'warning',
        duration: 0,
        message: '当前登录密码过于简单，存在数据泄露风险，请修改密码！'
      })
    }
    this.checkBusinessQualification()
  },
  created() {
    this.getNeedPop()
    this.update()
    this.getOrderBillingServiceStatu()
    this.getQualityGoodsNum()
  },
  beforeDestroy() {
    this.messgeTip && this.messgeTip.close()
  },
  computed: {
    includeCachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.fullPath
    },
    ...mapGetters('down', {
      // 获取 下载中心的数据
      downs: 'showList',
      hintsLength: 'hintsLength',
      hintStatus: 'hintStatus'
    })
  },
  methods: {
    perfection() {
      this.NoOrderBillingService = false
      sessionStorage.setItem('NoOrderBillingService', 1)
      this.$router.push('/financialEdit')
    },
    getOrderBillingServiceStatu() {
      this.$axios
        .get('/popadmin/admin/supplierEnter/financeDetail/detail')
        .then(success => {
          if (success.data.data.orderBillingService === 1) {
            this.NoOrderBillingService = true
          } else {
            sessionStorage.setItem('NoOrderBillingService', '')
          }
        })
        .catch(() => {
          sessionStorage.setItem('NoOrderBillingService', '')
        })
    },
    goToBusinessFn() {
      window.open('//edu.yunjiglobal.com/')
    },
    goToHelpFn() {
      window.open('//xinyunadmin.yunjiglobal.com/xinyunweb/businessHelpCenter/helpIndex')
    },
    /** 下載中心提示框的方法 */
    // 点击下载
    clickDown(data) {
      this.$axios.get(`/popadmin/admin/down/msg/downUrl?id=${data.id}`).then(res => {
        window.location = `${baseUrl}/download?fileName=${res.data.data}`
      })
    },
    // 点击每一项
    skipDownloads(data) {
      // 当用户未完善开票信息时不能离开 财务信息编辑页面
      if (sessionStorage.getItem('NoOrderBillingService') == 1) {
        this.$alert('您还未完善开票信息，请完善!', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return false
      }
      this.$router.push({
        name: 'downloads',
        query: { id: data.id }
      })
      // this.$router.push({
      //     path: '/downloads',
      //     query: {
      //       isKeepAlive:0,
      //       id: data.id
      //     }
      //   })
    },
    ...mapMutations('down', {
      // 修改提示框状态的方法
      show: 'SHOW',
      hide: 'HIDE',
      pollend: 'POLLEND'
    }),
    ...mapActions('down', ['update', 'pollstart']), // 改变下载提示数据

    checkNewTaskStatus() {
      homeServices.checkNewTaskStatus().subscribe(sucess => {
        this.$store.dispatch('updateUserInfo', sucess.data)
        if (sucess.data && sucess.data.storeCode) {
          localStorage.setItem('storeCode', sucess.data.storeCode)
        }
        this.user = sucess.data
        if (sucess.data && sucess.data.isNeedPopup === '1') this.wXVisible = true
        if (sucess.data && sucess.data.newbieTaskStatus == 1) {
          this.$router.replace({
            name: 'newcomerLogo',
            query: {
              registeredAddress: sucess.data.registeredAddress,
              storeCode: sucess.data.storeCode
            }
          })
        } else {
          this.countSupplierUpcomingLetter()
        }
      })
    },
    showViews(item) {
      // 当用户未完善开票信息时不能离开 财务信息编辑页面
      if (sessionStorage.getItem('NoOrderBillingService') == 1) {
        this.$alert('您还未完善开票信息，请完善!', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return false
      }
      if (item.isIframe) {
        this.deleteTagsView(item)
      } else {
        this.$router.push({ path: item.path, query: item.query })
      }
    },
    deleteTagsView(item) {
      const view = item
      view.path = item.path.replace('iframe?src=', '')
      if (document.getElementsByTagName('iframe').length) {
        const { host } = window.location
        const MessageType = ['popMarketing/discountEdit', 'popMarketing/shopCoupon', 'popMarketing/goodsCoupon']
        const { src } = document.getElementsByTagName('iframe')[0]
        const fg = MessageType.some(item => {
          if (src.includes(item)) {
            this.isJumpLink(view)
            this.listenChildMsg()
            return true
          }
          return false
        })
        if (!fg) {
          document.getElementsByTagName('iframe')[0].src = `${window.location.protocol}//${host}${view.path}`
          this.$store.dispatch('delAllViews')
        }
      }
    },
    isJumpLink(view) {
      document.getElementsByTagName('iframe')[0].contentWindow.postMessage(
        {
          type: 'parentMessage',
          parentUrl: view.path
        },
        '*'
      )
    },
    listenChildMsg() {
      const self = this
      window.addEventListener('message', e => {
        const data = e.data.msg
        if (data) {
          if (data.isSignOut) {
            let host = ''
            host = window.location.host
            document.getElementsByTagName('iframe')[0].src = `${window.location.protocol}//${host}${data.parentUrl}`
            self.$store.dispatch('delAllViews')
          }
        }
      })
    },
    findFirstCateg() {
      // = true;
      homeServices.findFirstCateg().subscribe(success => {
        this.firstCategList = success.data
      })
    },
    historyGoback() {
      this.$store.dispatch('delNextAllViews', this.$route)
      this.$router.go(-1)
    },
    domScroll(val) {
      this.$refs.routerId.scroll(0, val)
    },

    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    judegeRoute(router) {
      return router === '/index'
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    },
    modifyPsw() {
      this.changePasswordDialog = true
    },
    /**
     * 日期格式化
     * */
    getDate(params) {
      if (!params) {
        return null
      }
      const tempDate = new Date(params)
      const yy = tempDate.getFullYear()
      let mm = tempDate.getMonth() + 1
      mm = mm < 10 ? `0${mm}` : mm
      let dd = tempDate.getDate()
      dd = dd < 10 ? `0${dd}` : dd
      let hh = tempDate.getHours()
      hh = hh < 10 ? `0${hh}` : hh
      let MM = tempDate.getMinutes()
      MM = MM < 10 ? `0${MM}` : MM
      let ss = tempDate.getSeconds()
      ss = ss < 10 ? `0${ss}` : ss
      return `${yy}-${mm}-${dd}`
    },

    /**
     * 获取登录用户信息
     * * */
    getUserInfo() {},
    /**
     * 下拉菜单页面
     * * */
    toggleMenu(index) {
      this.menu[index].showSubMenu = !this.menu[index].showSubMenu
      if (this.menu[index].showSubMenu == true) {
        // 打开一个菜单，其他菜单都关闭
        this.menu.forEach((item, idx) => {
          if (index != idx) {
            this.menu[idx].showSubMenu = false
          }
        })
      }
    },
    toggleSubMenu(index, subIndex) {
      this.menu[index].chirdMenuList[subIndex].showSubSubMenu = !this.menu[index].chirdMenuList[subIndex].showSubSubMenu
    },
    logout() {
      //   window.sessionStorage.MENULIST_STORAGE = "";
      this.$store.dispatch('delAllViews').then(views => {
        homeServices.postOut().subscribe(
          data => {
            localStorage.clear()
            this.clearCookie()
            window.sessionStorage.SELECTED_NAV_STORAGE = ''
            this.$store.dispatch('delUserInfo')
            this.$router.replace('/login') // 返回登录页面
          },
          error => {
            this.$router.replace('/login') // 返回登录页面
          }
        )
      })
    },
    clearCookie() {
      const keys = document.cookie.match(/[^ =;]+(?=\=)/g)
      if (keys) {
        for (let i = keys.length; i--; ) {
          document.cookie = `${keys[i]}=0;path=/;expires=${new Date(0).toUTCString()}` // 清除当前域名下的,例如：m.kevis.com
          document.cookie = `${keys[i]}=0;path=/;domain=${document.domain};expires=${new Date(0).toUTCString()}` // 清除当前域名下的，例如 .m.kevis.com
          document.cookie = `${keys[i]}=0;path=/;domain=.yunjiglobal.com;expires=${new Date(0).toUTCString()}` // 清除一级域名下的或指定的，例如 .kevis.com
        }
      }
    },
    goToRuleFn() {
      // if (process.env.NODE_ENV === 'production') {
      //   window.open('http://rule.yunjiglobal.com/ruleadminweb/index', '_blank')
      // } else {
      //   window.open(`${window.location.protocol}//${window.location.host}/ruleadminweb/index`, '_blank')
      // }
      if (window.location.host === 't-do-dev.yunjiglobal.com') {
        window.open(`${window.location.protocol}//${window.location.host}/ruleadminweb/index`, '_blank')
      } else {
        window.open('http://rule.yunjiglobal.com/ruleadminweb/index', '_blank')
      }
    },
    /**
     * 查询是否有待办促销函
     */
    countSupplierUpcomingLetter() {
      if (this.ignoreCheckList.includes(window.location.pathname)) return
      const storeCode = this.user && this.user.storeCode ? this.user.storeCode : ''
      if (!storeCode) return
      // 函数据
      const promotionLetterData = this.$axios
        .get(`/popadmin/admin/promotion/common/countSellerUpcomingLetter?storeCode=${storeCode}`)
        .then(res => res.data.data)
      // 查询是否有临期，过期的资质
      const qualificationsData = this.$axios
        .get('/popadmin/admin/popGoodsQualification/findPopGoodsQualityStatusCount')
        .then(res => res.data.data)
      // 弹窗公告数据
      const noticeData = this.$axios
        .post('/popadmin/admin/popAnnouncement/getUnReadAnnouncement')
        .then(res => res.data.data || [])
      // 抽奖奖品数据
      const prizeData = this.$axios.post('/popadmin/admin/live/awardTips').then(res => res.data.data || [])
      Promise.all([promotionLetterData, qualificationsData, noticeData, prizeData]).then(res => {
        const [promotionLetterData, qualificationsData, noticeData, prizeData] = res
        this.beTimeoutUnSendCount = prizeData.beTimeoutUnSendCount
        this.noticeDialogDataList = noticeData
        if (promotionLetterData) {
          this.promiseNum =
            promotionLetterData.popPromiseConfirm +
            promotionLetterData.popPromiseSignature +
            promotionLetterData.popPromiseBillConfirm +
            promotionLetterData.popPromisePaperContact
          this.costNum =
            promotionLetterData.popCostConfirm +
            promotionLetterData.popCostPaperContact +
            promotionLetterData.popCostSignature
          this.saleToolNeedHandActivityCount = promotionLetterData.saleToolNeedHandActivityCount || 0
        }
        if (qualificationsData) {
          this.adventCount = qualificationsData.adventCount || 0
          this.expiredCount = qualificationsData.expiredCount || 0
        }
        if (this.noticeDialogDataList.length) {
          this.showNoticeData(0)
        } else {
          this.showPromotionCheckDialog()
        }
      })
    },
    /**
     * 跳转到促销承诺函
     * promotionCheck 1=促销承诺函查询特定参数
     */
    toPromise() {
      this.$router.push({
        path: '/promise',
        query: {
          promotionCheck: 1
        }
      })
      this.promotionCheckDialog = false
      this.qualificationCheckDialog = true
    },
    /**
     * 跳转到抽奖发货管理
     */
    toDrawRecord() {
      this.$router.push({
        path: '/drawRecordToB'
      })
      this.promotionCheckDialog = false
      this.qualificationCheckDialog = true
    },
    /**
     * 跳转到促销费用函
     * promotionCheck 1=促销费用函查询特定参数
     */
    toCost() {
      this.$router.push({
        path: '/cost',
        query: {
          promotionCheck: 1
        }
      })
      this.promotionCheckDialog = false
      this.qualificationCheckDialog = true
    },
    closePromotionCheckDialog() {
      this.promotionCheckDialog = false
      this.qualificationCheckDialog = true
    },
    toGoodsQualificationList(activeName) {
      this.promotionCheckDialog = false
      this.$router.push({
        path: '/goodsQualificationList',
        query: {
          activeName: activeName
        }
      })
      this.qualificationCheckDialog = true
    },
    // 公告数据弹窗展示数据
    showNoticeData(index) {
      if (this.noticeDialogDataList.length) {
        this.noticeDialogData = this.noticeDialogDataList[index]
        this.noticeDialogData.attachFileJson = JSON.parse(this.noticeDialogData.attachFileJson)
        this.noticeDialog = true
      }
    },
    // 公告弹窗，下一条点击
    handleNext() {
      this.noticeDialogDataIndex += 1
      this.showNoticeData(this.noticeDialogDataIndex)
    },
    // 公告弹窗点击我知道了
    handleNoticeSubmit() {
      const announcementIds = []
      this.noticeDialogDataList.forEach(item => {
        announcementIds.push(item.id)
      })
      this.$axios
        .post('/popadmin/admin/popAnnouncement/signAnnouncementAsRead', { announcementIds: announcementIds })
        .then(res => {
          if (res.data.code === 0) {
            this.noticeDialog = false
          }
          this.showPromotionCheckDialog()
        })
    },
    // 公告下载
    noticeDownload(item) {
      location.href = `/popadmin/admin/popAnnouncement/download?url=${item.url}&fileName=${item.fileName}`
    },
    // 促销函弹窗显示
    showPromotionCheckDialog() {
      this.promotionCheckDialog =
        this.promiseNum + this.costNum + this.adventCount + this.expiredCount + this.saleToolNeedHandActivityCount > 0
      if(!this.promotionCheckDialog) {
        this.qualificationCheckDialog = true
      }
    },
    // 重要待办弹窗
    getNeedPop() {
      this.$axios.get('/popadmin/admin/supplierEnter/todoCenter/isPopup').then(res => {
        if (res.data.code == 0 && res.data.data) {
          this.outerVisible = true
        }
      })
    },
    // 去到待办中心
    gotoNeedCenter() {
      this.outerVisible = false
      this.$router.push({
        path: '/needCenter'
      })
    },
    gotoPage() {
      this.wXVisible = false
      this.$router.push({
        path: '/weChatAccountOpen'
      })
    },
    // 跳转营销工具报名
    toMarketsignup() {
      this.$router.push({
        path: '/marketsignup'
      })
      this.promotionCheckDialog = false
      this.qualificationCheckDialog = true
    },
    // 0718需求，增加半年资质校验
    checkBusinessQualification(){
      //console.log("调用接口，半年资质校验")
      homeServices.checkBusinessQualificationExpire().subscribe(success => {
        console.log("checkBusinessQualification",success)
        this.visible = success.data
        if (this.visible) {
          this.getExpire()
        }
      })
    },
    getExpire() {
      homeServices.getBusinessQualificationExpire().subscribe(success => {
        if(success.response.data.code == 0) {
          console.log("获取过期时间", success.response.data)
          let newDate = new Date(success.response.data.data)
          this.expireDate = this.formateDate(newDate, 'yyyy-MM-dd')
        }
      })
    },
    formateDate (date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
        }
      }
      return fmt
    },
    padLeftZero (str) {
      return ('00' + str).substr(str.length)
    },
    submit(action) {
      // console.log("用户操作",action)
      homeServices.insertCheckLog(action).subscribe(success => {
        console.log(success)
        if(success.response.data.code ==0) {
          if(action == 1) {
            this.$router.push({ 
              path: '/shopInfo?tabActive=2'
            })
          }
          this.visible = false
        } else {
          this.$message.success(success.response.msg)
        }
      })
    },
    // 获取各状态资质商品数量
    getQualityGoodsNum(){
      homeServices.getQualityGoodsNum().subscribe(success => {
        console.log("getQualityGoodsNum res",success)
        const res = success.response.data;
        if(res.code == 0) {
          this.adventDateNum = res.data.adventDateNum;
          this.outDateNum =  res.data.outDateNum;
          this.rejectNum =  res.data.rejectNum;
        }
      })
    },
    toAdventDateQualification(){
      this.$router.push({
        path: '/goodsQualificationList',
        query: {
          activeName: 'adventList',
          isRelatedShelf: '1'
        }
      })
      this.promotionCheckDialog = false
      this.qualificationCheckDialog = true
    },
    toOutDateQualification(){
      this.$router.push({
        path: '/goodsQualificationList',
        query: {
          activeName: 'expiresList',
          isRelatedShelf: '1'
        }
      })
      this.promotionCheckDialog = false
      this.qualificationCheckDialog = true
    },
    toRejectQualification(){
      this.$router.push({
        path: '/goodsQualificationList',
        query: {
          activeName: 'overruleList'
        }
      })
      this.promotionCheckDialog = false
      this.qualificationCheckDialog = true
    }
  }
}
